// import logo from './logo.svg';
// import './App.css';
import React, { Component } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import $ from 'jquery'
import Header from "./Component/Header";
import Login from "./Component/Login";
import LothunMenu from "./Component/LothunMenu";
import LottoMenu from "./Component/LottoMenu";
import DataContext from "./data/DataContext";
import dataConfig from "./data/config";
import Swal from 'sweetalert2'
import LottoWin from "./Component/Lotto/LottoWin";
import LottoMoney from "./Component/Lotto/LottoMoney";
import LothunWin from "./Component/Lothun/LothunWin";
import LothunMoney from "./Component/Lothun/LothunMoney";
import Setting from "./Component/Setting";
import Password from "./Component/Password";
import Loading from "./Component/Loading";
import Notify from "./Component/Notify";
import LothunPayMoney from "./Component/Lothun/LothunPayMoney";
import LottoPayMoney from "./Component/Lotto/LottoPayMoney";
import News from "./Component/News";
import NotifyTelegram from "./Component/NotifyTelegram";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      a_id: localStorage.getItem("_id"),
      a_user: localStorage.getItem("username"),
      a_name: localStorage.getItem("name"),
      a_login: localStorage.getItem("login"),
      a_level: localStorage.getItem("level"),
      a_pass: localStorage.getItem("pass"),
      loading: false
    };
  }
  render() {

    const loginAccess = (a_id, a_user, a_name, a_login, a_level, a_pass) => {
      this.setState({ ...this.state, a_id: a_id, a_user: a_user, a_name: a_name, a_login: a_login, a_level: a_level, a_pass: a_pass });
    }
    const blockUI = (ui = false) => {
      if (ui) {
        $('body').addClass('onPageLoad')
      } else {
        $('body').removeClass('onPageLoad')
      }

    }
    // const sessionExp = (error)=>{
    //   localStorage.clear();
    //   this.setState({loading:false,a_id:null,a_user:null,a_name:null,a_login:null,a_level:null});
    //   Swal.fire({
    //     title: 'เซ็คชั่นหมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง',
    //     text: '',
    //     icon: 'warning',
    //     confirmButtonText: 'ตกลง',
    //     confirmButtonColor: '#185ADB',
    //   })
    // }
    return (
      <BrowserRouter>
        <DataContext.Provider value={{ ...dataConfig, loginAccess: loginAccess, ...this.state, blockUI: blockUI }} >
          <div className="App">
            <Loading />
            <Routes>
              <Route path={"/login"} element={<>
                {this.state.a_login ? <Navigate to="/lotto/win" /> : <Login />}
              </>} />
              <Route path={"/"} element={<>
                {!this.state.a_login ? <Login /> : <Navigate to="/lotto/win" />}
              </>} />
              <Route path={"/lotto/win"} element={<>
                {!this.state.a_login ? <Login /> :
                  <>
                    <Header />
                    <LottoMenu />
                    <LottoWin />
                  </>
                }

              </>} />
              <Route path={"/lothun/win"} element={<>
                {!this.state.a_login ? <Login /> :
                  <>
                    <Header />
                    <LothunMenu />
                    <LothunWin />
                  </>
                }
              </>} />
              <Route path={"/password"} element={<>
                {!this.state.a_login ? <Login /> :
                  <>
                    <Header />
                    <Password />
                  </>
                }
              </>} />

              {process.env.REACT_APP_ADMIN_TYPE == 'SA' &&
                <>
                  <Route path={"/lotto/money"} element={<>
                    {!this.state.a_login ? <Login /> :
                      <>
                        <Header />
                        <LottoMenu />
                        <LottoMoney />
                      </>
                    }
                  </>} />
                  <Route path={"/lotto/paymoney"} element={<>
                    {!this.state.a_login ? <Login /> :
                      <>
                        <Header />
                        <LottoMenu />
                        <LottoPayMoney />
                      </>
                    }
                  </>} />

                  <Route path={"/lothun/money"} element={<>
                    {!this.state.a_login ? <Login /> :
                      <>
                        <Header />
                        <LothunMenu />
                        <LothunMoney />
                      </>
                    }
                  </>} />
                  <Route path={"/lothun/paymoney"} element={<>
                    {!this.state.a_login ? <Login /> :
                      <>
                        <Header />
                        <LothunMenu />
                        <LothunPayMoney />
                      </>
                    }
                  </>} />
                  <Route path={"/notify"} element={<>
                    {!this.state.a_login ? <Login /> :
                      <>
                        <Header />
                        {/* <Notify /> */}
                        <NotifyTelegram />
                      </>
                    }
                  </>} />
                  <Route path={"/news"} element={<>
                    {!this.state.a_login ? <Login /> :
                      <>
                        <Header />
                        <News />
                      </>
                    }
                  </>} />
                  <Route path={"/setting"} element={<>
                    {!this.state.a_login ? <Login /> :
                      <>
                        <Header />
                        <Setting />
                      </>
                    }
                  </>} />
                </>
              }

              {/*  */}
              <Route path={"*"} element={<>
                {!this.state.a_login ? <Login /> :
                  <>
                    <Header />
                    <h2 className="text-center" style={{ margin: '50px' }}> ไม่พบหน้าที่คุณต้องการ</h2>
                  </>
                }
              </>} />
            </Routes>
          </div>
        </DataContext.Provider>
      </BrowserRouter>

    );
  }

  componentDidUpdate() {
    // console.log('Update app')
    // if(this.state.a_login){
    //   let login = new Date(this.state.a_login).getTime();
    //   let now = new Date().getTime();
    //   console.log(login+3600*60*3)
    //   console.log(now)
    //   if(login+3600*60*3 < now && this.state.a_login !== null && this.state.a_login !== undefined && this.state.a_login !== ''){
    //     Swal.fire({
    //       title: 'เซ็คชั่นหมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง',
    //       text: '',
    //       icon: 'warning',
    //       confirmButtonText: 'ตกลง',
    //       confirmButtonColor: '#185ADB',
    //     })
    //     this.setState({loading:false,a_id:null,a_user:null,a_pass:null,a_name:null,a_login:null,a_level:null});
    //   }
    // }

  }

  componentDidMount() {
    // console.log('start app')
    if (this.state.a_login) {
      let login = new Date(this.state.a_login).getTime();
      let now = new Date().getTime();
      // console.log(login+3600*60*3)
      // console.log(now)
      if (login + (1000 * 60 * 60) < now && this.state.a_login !== null && this.state.a_login !== undefined && this.state.a_login !== '') {
        Swal.fire({
          title: 'เซ็คชั่นหมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง',
          text: '',
          icon: 'warning',
          confirmButtonText: 'ตกลง',
          confirmButtonColor: '#185ADB',
        })
        this.setState({ loading: false, a_id: null, a_user: null, a_pass: null, a_name: null, a_login: null, a_level: null });
        localStorage.clear();
      }
    }
  }
}

export default App;
